export default __webpack_public_path__ + "static/media/chat.4dbb4651.svg";